import { CalibrationPairs, CalibrationType } from '../../interfaces/homography';

export type ActiveMapMarker = [number, google.maps.LatLng];

export interface CalibrationPairsState extends CalibrationPairs {
  contextScale: number;
  lprScale: number;
  modified: boolean;
  calculatedHomography: Float32Array;
}

export interface CalibrationMapState extends CalibrationPairs {
  contextScale: number;
  modified: boolean;
  calculatedHomography: Float32Array;
  activeMarkers: ActiveMapMarker[];
}

export interface HomographyState {
  lPRPairs: CalibrationPairsState;
  nightLPRPairs: CalibrationPairsState;
  mapPairs: CalibrationMapState;
  isSubmitting: boolean;
}

export const initialHomographyState: HomographyState = {
  lPRPairs: {
    calibrationType: CalibrationType.LPR,
    imagePairs: {
      imageOne: {
        name: 'context',
        points: [],
      },
      imageTwo: {
        name: 'lpr',
        points: [],
      },
    },
    contextScale: 1,
    lprScale: 1,
    modified: false,
    calculatedHomography: null,
  } as CalibrationPairsState,
  nightLPRPairs: {
    calibrationType: CalibrationType.NIGHTLPR,
    imagePairs: {
      imageOne: {
        name: 'context',
        points: [],
      },
      imageTwo: {
        name: 'lpr',
        points: [],
      },
    },
    contextScale: 1,
    lprScale: 1,
    modified: false,
    calculatedHomography: null,
  } as CalibrationPairsState,
  mapPairs: {
    calibrationType: CalibrationType.MAP,
    imagePairs: {
      imageOne: {
        name: 'context',
        points: [],
      },
      imageTwo: {
        name: 'map',
        points: [],
      },
    },
    contextScale: 1,
    modified: false,
    calculatedHomography: null,
    activeMarkers: [],
  } as CalibrationMapState,
  isSubmitting: false,
};
